type FileSizeUnit = 'B' | 'KB' | 'MB' | 'GB' | 'TB';
interface FileSizeOptions {
  unit?: FileSizeUnit;
  file: File;
  decimalPlaces?: number;
}

const fileSizeCalculations: Record<FileSizeUnit, (size: number) => number> = {
  B: (size) => size,
  KB: (size) => size / 1024,
  MB: (size) => size / 1024 / 1024,
  GB: (size) => size / 1024 / 1024 / 1024,
  TB: (size) => size / 1024 / 1024 / 1024 / 1024,
};

export function getFileSize({ file, unit = 'MB', decimalPlaces = 2 }: FileSizeOptions) {
  const sizeInBytes = file.size;
  const sizeInUnit = fileSizeCalculations[unit](sizeInBytes);
  const sizeInUnitWithDecimalPlaces = sizeInUnit.toFixed(decimalPlaces);
  return sizeInUnitWithDecimalPlaces;
}

export function getFileNameWithoutExtension(fileName: string) {
  return fileName.replace(/\.[^/.]+$/, '');
}
